import axios from 'axios'
import { baseUrl } from './config'

export function getStatisticsBets (params) {
  return axios.get(`${baseUrl}/catcher-game/statistics/bets`, {
    params
  })
}

export function getStatisticsRounds (params) {
  return axios.get(`${baseUrl}/catcher-game/statistics/rounds`, {
    params
  })
}

export function getDelay () {
  return axios.get(`${baseUrl}/catcher-game/delay`)
}

export function updateDelay (delay) {
  return axios.post(`${baseUrl}/catcher-game/delay`, {
    delay
  })
}

export function getGeneralStatistics () {
  return axios.get(`${baseUrl}/catcher-game/statistics/general`)
}

export function startWheel () {
  return axios.post(`${baseUrl}/catcher-game/start`)
}

export function stopWheel () {
  return axios.post(`${baseUrl}/catcher-game/stop`)
}
